import { render, staticRenderFns } from "./GeneralCollectionsSettings.vue?vue&type=template&id=593c3d59&scoped=true&"
import script from "./GeneralCollectionsSettings.vue?vue&type=script&lang=ts&"
export * from "./GeneralCollectionsSettings.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralCollectionsSettings.vue?vue&type=style&index=0&id=593c3d59&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593c3d59",
  null
  
)

export default component.exports